var _circle, _circle2, _path, _path2, _path3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallationPompeAChaleurAirEau5579597Aab2A4604D680(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 40.5,
    fill: "white",
    stroke: "#08305E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.0001,
    cy: 41,
    r: 29.8182,
    fill: "#08305E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3702 39.7045C37.4051 37.912 73.2069 38.4627 63.46 55.3448C53.7132 72.2268 35.3353 41.4969 36.3702 39.7045Z",
    fill: "#E2F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9423 47.4322C38.8725 47.4322 21.4485 16.1515 40.9422 16.1515C60.436 16.1515 43.012 47.4322 40.9423 47.4322Z",
    fill: "#E2F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3266 39.7045C44.2917 37.912 8.48988 38.4627 18.2367 55.3448C27.9836 72.2268 46.3615 41.4969 45.3266 39.7045Z",
    fill: "#E2F0FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.8665,
    cy: 42.4454,
    r: 4.08009,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallationPompeAChaleurAirEau5579597Aab2A4604D680);
export default __webpack_public_path__ + "static/media/installation_pompe_a_chaleur_air_eau.5579597aab2a4604d680.5579597aab2a4604d68039e7d0372807.svg";
export { ForwardRef as ReactComponent };